@if(itemGeneralFormReady()) {
    <form autocomplete="off" [formGroup]="itemGeneralFormService.form"
            class="form tw-p-5 tw-pb-10 tw-flex tw-flex-col tw-gap-5">
        <ng-container formGroupName="detailsForm">
            <section class="tw-px-4 tw-grid tw-grid-cols-12 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
                <div class="tw-col-span-12 tw-flex tw-items-center tw-cursor-pointer tw-select-none"
                    (click)="itemGeneralFormService.favorite?.setValue(!itemGeneralFormService.favorite?.value)"
                    [title]="itemGeneralFormService.favorite?.value ? ('ITEMS.DETAILS.REMOVE_FAVORITE' | translate) : ('ITEMS.DETAILS.ADD_FAVORITE' | translate)">
                    
                    <div class="bookmark-icon tw-pr-3 tw-flex tw-items-center">
                        <span [ngClass]="{'filled' : itemGeneralFormService.favorite?.value}" 
                            class="material-symbols-rounded">
                            star
                        </span>
                    </div>
    
                    <span class="tw-text-sm md:tw-text-base">
                        {{ (itemGeneralFormService.favorite?.value ? 'ITEMS.DETAILS.REMOVE_FAVORITE' : 'ITEMS.DETAILS.ADD_FAVORITE') | translate }}
                    </span>
                </div>
    
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle class="tw-p-2" formControlName="on_sale" aria-label="{{'ITEMS.DETAILS.FOR_SALE' | translate}}">{{'ITEMS.DETAILS.FOR_SALE' | translate}}</mat-slide-toggle>
                </div>
    
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle class="tw-p-2" formControlName="not_discountable" 
                    aria-label="{{'ITEMS.DETAILS.NOT_DISCOUNTABLE' | translate}}">{{'ITEMS.DETAILS.NOT_DISCOUNTABLE' | translate}}</mat-slide-toggle>
                </div>
    
                <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
                    <mat-slide-toggle class="tw-p-2" formControlName="request_weighing" aria-label="{{'ITEMS.DETAILS.REQUEST_WEIGHING' | translate}}">{{'ITEMS.DETAILS.REQUEST_WEIGHING' | translate}}</mat-slide-toggle>
                </div>
            </section>
    
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.ITEM_DATA</mat-label>
    
            <section>
                <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.NAME</mat-label>
                        <input matInput formControlName="name" required appTrimInput>
                        @if(isAlternativeTranslateEnabled) {
                            <mat-icon 
                                matIconSuffix
                                #tooltip_orderName="matTooltip"
                                class="tw-cursor-pointer tw-text-gray-500"
                                [matTooltip]="'ITEMS.ALTERNATIVE_TRANSLATE' | translate"
                                matTooltipPosition="above"
                                (click)="manageAlternativeTranslate()" 
                                aria-label="'ITEMS.ALTERNATIVE_TRANSLATE' | translate">
                                language_outlined
                            </mat-icon>
                        }
                        <mat-hint [align]="'end'">{{itemGeneralFormService.name?.value?.length || '0'}}
                            / {{itemGeneralFormService.validators.nameMaxLength}}</mat-hint>
                        @if(itemGeneralFormService.name?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{itemGeneralFormService.validators.nameMaxLength}})</mat-error>
                        } @else if(itemGeneralFormService.name?.hasError('required')) {
                            <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                        }
                    </mat-form-field>
        
                    <!-- <ng-container [formGroup]="itemGeneralFormService.pricesForm">
                        @if (priceList && priceList[0]; as firstPrice) {
                            <mat-form-field class="md:tw-col-span-4">
                                <mat-label>{{'ITEMS.DETAILS.PRICE' | translate: firstPrice }}</mat-label>
                                <input matInput type="number" [formControlName]="firstPrice.priceFieldName" [required]="firstPrice.required" step="0.01">
                                @if(itemGeneralFormService.getPrice(firstPrice.priceFieldName)?.hasError('min')) {
                                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                                } @else if (itemGeneralFormService.getPrice(firstPrice.priceFieldName)?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field class="md:tw-col-span-4">
                                <mat-label>{{firstPrice.departmentLabel}}</mat-label>
                                <mat-select [formControlName]="firstPrice.departmentFieldName" [required]="firstPrice.required">
                                    <mat-option *ngFor="let dep of departmentsList" [value]="dep.id">{{dep.name}} {{getDepartmentVat(dep.vat)}}</mat-option>
                                </mat-select>
                                @if (itemGeneralFormService.getDepartment(firstPrice.departmentFieldName)?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        }
                    </ng-container> -->
        
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.CATEGORY</mat-label>
                        <mat-select formControlName="category"
                            (selectionChange)="onChangeCategory()"
                        >
                            @for(cat of categoriesList; track cat.id) {
                                <mat-option [value]="cat.id">{{ cat.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
        
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.COLOR</mat-label>
                        <mat-select formControlName="color" panelClass="no-select-panel-padding">
                            <mat-select-trigger>
                                <div class="tw-flex tw-items-center tw-gap-2">
                                    @if(itemGeneralFormService.color?.value) {
                                        <span class="item-details-color-preview" [style.backgroundColor]="'#'+itemGeneralFormService.color?.value"></span>
                                    }
                                    <span>{{ getSelectedColorName() }}</span>
                                </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let col of colorItems" [value]="col.value"
                                [ngStyle]="{'background-color': col.value ? '#' + col.value : 'none'}">
                                {{col.name | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
        
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.INDEX</mat-label>
                        <input matInput type="number" formControlName="index">
                        @if(itemGeneralFormService.index?.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.SKU</mat-label>
                        <input matInput formControlName="sku" appTrimInput>
                        <mat-hint [align]="'end'">{{itemGeneralFormService.sku?.value?.length || '0'}}
                            / {{itemGeneralFormService.validators.skuMaxLength}}</mat-hint>
                        @if(itemGeneralFormService.sku?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                                (max. {{itemGeneralFormService.validators.skuMaxLength}})
                            </mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                        <mat-label translate>ITEMS.DETAILS.CODE</mat-label>
                        <input matInput formControlName="code" appTrimInput>
                        <mat-hint [align]="'end'">{{itemGeneralFormService.code?.value?.length || '0'}}
                            / {{itemGeneralFormService.validators.codeMaxLength}}</mat-hint>
                        @if(itemGeneralFormService.code?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                                (max. {{itemGeneralFormService.validators.codeMaxLength}})
                            </mat-error>
                        }
                    </mat-form-field>

                    @if(useNewBarcodeQty) {
                        <div class="md:tw-col-span-6 lg:tw-col-span-4">
                            <app-barcode-selector formControlName="barcodes"></app-barcode-selector>
                        </div>
                    } @else {
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-chip-grid #barcodeChipGrid aria-label="Enter barcode">
                                @for (barcode of itemGeneralFormService.barcodes?.value; track barcode) {
                                    <mat-chip-row (removed)="removeBarcode(barcode.barcode)" 
                                        class="my-custom-chip-color"
                                    >
                                        <strong>{{barcode.barcode}}</strong>
                                        <button matChipRemove [attr.aria-label]="'remove barcode' + barcode.barcode">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                                <input
                                    placeholder="Barcode"
                                    [matChipInputFor]="barcodeChipGrid"
                                    (matChipInputTokenEnd)="addBarcodeFromChip($event)"
                                />
                            </mat-chip-grid>
    
                            @if(isCameraBarcodeSupported) {
                                <mat-icon 
                                    matIconSuffix
                                    #tooltip_orderName="matTooltip"
                                    class="tw-cursor-pointer tw-text-gray-500"
                                    [matTooltip]="'ITEMS.BARCODE_SCANNER' | translate"
                                    matTooltipPosition="above"
                                    (click)="openBarcodeAndSearch()" 
                                    aria-label="'ITEMS.BARCODE_SCANNER' | translate">
                                    photo_camera
                                </mat-icon>
                            }
                        </mat-form-field>
                    }
        
                </section>
        
                @if (showMoreDetails) {
                    <section class="tw-pt-3 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label translate>ITEMS.DETAILS.SEASON</mat-label>
                            <input matInput formControlName="season" appTrimInput>
                            <mat-hint [align]="'end'">{{itemGeneralFormService.season?.value?.length || '0'}}
                                / {{itemGeneralFormService.validators.seasonMaxLength}}</mat-hint>
                            @if(itemGeneralFormService.season?.hasError('maxlength')) {
                                <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                                    (max. {{itemGeneralFormService.validators.seasonMaxLength}})
                                </mat-error>
                            } @else if(itemGeneralFormService.season?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD'| translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label translate>ITEMS.DETAILS.BRAND</mat-label>
                            <input matInput formControlName="brand" appTrimInput>
                            <mat-hint [align]="'end'">{{itemGeneralFormService.brand?.value?.length || '0'}}
                                / {{itemGeneralFormService.validators.brandMaxLength}}</mat-hint>
                            @if(itemGeneralFormService.brand?.hasError('maxlength')) {
                                <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{itemGeneralFormService.validators.brandMaxLength}})</mat-error>
                            } @else if(itemGeneralFormService.brand?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD'| translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label translate>ITEMS.DETAILS.KEYBOARD_CODE</mat-label>
                            <input matInput formControlName="keyboard_code" appTrimInput>
                            @if(itemGeneralFormService.keyboard_code?.hasError('pattern')) {
                                <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label>{{'ITEMS.DETAILS.DEFAULT_SUPPLIER' | translate}}</mat-label>
                            <input matInput formControlName="default_supplier_id" [matAutocomplete]="supplierAutocomplete" appTrimInput>
                            @if(itemGeneralFormService.default_supplier_id?.hasError('matchRequired')){
                                <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                            }
                            <mat-autocomplete #supplierAutocomplete="matAutocomplete" [displayWith]="displaySupplierName" [autoSelectActiveOption]="true">
                                @for(supplier of filteredSuppliers | async; track supplier.id) {
                                    <mat-option [value]="supplier.id">{{ supplier.name }}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
        
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label translate>ITEMS.DETAILS.UNIT</mat-label>
                            <input matInput type="text" formControlName="unit" [matAutocomplete]="auto" appTrimInput>
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUnit">
                            <mat-option *ngFor="let option of filteredUnits | async" [value]="option.value">
                                {{option.name}}
                            </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
        
                        <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                            <mat-label translate>ITEMS.DETAILS.WEIGHT</mat-label>
                            <input matInput type="number" formControlName="weight" step="0.001">
                            @if(itemGeneralFormService.weight?.hasError('min')) {
                                <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        @if(isPienissimoEnabled) {
                            <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                                <mat-label translate>ITEMS.DETAILS.PIENISSIMO_CODE</mat-label>
                                <input matInput formControlName="code_pienissimo" appTrimInput>
                                <mat-hint [align]="'end'">{{itemGeneralFormService.code_pienissimo?.value?.length || '0'}}
                                    / {{itemGeneralFormService.validators.codePienissimoMaxLength}}</mat-hint>
                                @if(itemGeneralFormService.season?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                                        (max. {{itemGeneralFormService.validators.seasonMaxLength}})
                                    </mat-error>
                                }
                            </mat-form-field>
                        }
                    </section>
                }
        
                <div class="tw-flex tw-px-3 tw-py-2">
                    <button mat-button color="primary" (click)="showMoreDetails = !showMoreDetails" type="button">
                        <mat-icon>{{ showMoreDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
                        {{ (showMoreDetails ? 'COMMON.SHOW_LESS' : 'COMMON.SHOW_MORE') | translate }}
                    </button>
                </div>
            </section>
        </ng-container>
    
        <ng-container formGroupName="pricesForm">
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.PRICES</mat-label>
            <section>
                <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                    @for(price of priceList; track price.index) {
                        <!-- @if ($index < initialPriceLimit() || showMorePriceDetails) { -->
                            <mat-form-field class="md:tw-col-span-6">
                                <mat-label>{{'ITEMS.DETAILS.PRICE' | translate: price }}</mat-label>
                                <input matInput type="number" [formControlName]="price.priceFieldName" step="0.01">
                            </mat-form-field>
    
                            <mat-form-field class="md:tw-col-span-6">
                                <mat-label>{{price.departmentLabel}}</mat-label>
                                <mat-select [formControlName]="price.departmentFieldName">
                                    <mat-option *ngFor="let dep of (price.required ? departmentsRequiredList : departmentsList)" [value]="dep.id">
                                        {{dep.name}} {{itemDataOperationsService.getDepartmentVat(dep.vat)}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        <!-- } -->
                    }
                </section>
        
                <!-- @if(priceList && priceList.length > initialPriceLimit()) {
                    <div class="tw-flex tw-px-3 tw-py-2">
                        <button mat-button color="primary" (click)="togglePriceDetails()" type="button">
                            <mat-icon>{{ showMorePriceDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
                            {{ (showMorePriceDetails ? 'COMMON.SHOW_LESS' : 'COMMON.SHOW_MORE') | translate }}
                        </button>
                    </div>
                } -->
            </section>
        </ng-container>
    
        <ng-container formGroupName="costsForm">
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.COST</mat-label>
            <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                    <mat-label translate>ITEMS.DETAILS.COST_NO_VAT</mat-label>
                    <input matInput type="number" formControlName="cost">
                    @if(itemGeneralFormService.cost?.hasError('min')) {
                        <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                    }
                </mat-form-field>
                
                <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                    <mat-label translate>ITEMS.DETAILS.ITEM_MARGIN</mat-label>
                    <input matInput readonly formControlName="itemMargin">
                </mat-form-field>
    
                <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-4">
                    <mat-label translate>ITEMS.DETAILS.ITEM_MARKUP</mat-label>
                    <input matInput readonly formControlName="itemMarkup">
                </mat-form-field>

                @if (itemLastMovements && itemLastMovements.length > 0) {
                    <div class="tw-col-span-1 md:tw-col-span-12 tw-min-w-0 tw-flex tw-flex-col">
                        <h4 class="tw-my-3"  translate>
                            ITEMS.DETAILS.LAST_MOVEMENTS.TITLE
                        </h4>

                        <div class="tw-overflow-x-auto">
                            <table mat-table [dataSource]="itemLastMovements" class="tw-w-full">

                                <!-- Colonna Prezzo -->
                                <ng-container matColumnDef="price">
                                    <th mat-header-cell *matHeaderCellDef translate> ITEMS.DETAILS.LAST_MOVEMENTS.PRICE </th>
                                    <td mat-cell *matCellDef="let row"> 
                                        {{ row.price | tilbyCurrency }} 
                                    </td>
                                </ng-container>

                                <!-- Colonna Fornitore -->
                                <ng-container matColumnDef="supplier">
                                    <th mat-header-cell *matHeaderCellDef translate> ITEMS.DETAILS.LAST_MOVEMENTS.SUPPLIER </th>
                                    <td mat-cell *matCellDef="let row"> 
                                        {{ row.supplier_name || ('ITEMS.DETAILS.LAST_MOVEMENTS.NOT_DEFINED' | translate) }} 
                                    </td>
                                </ng-container>

                                <!-- Colonna Data -->
                                <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef translate> ITEMS.DETAILS.LAST_MOVEMENTS.DATE </th>
                                    <td mat-cell *matCellDef="let row"> 
                                        {{ row.date | tilbyDate:'dd/MM/yyyy HH:mm' }} 
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsLastMovementsTable"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsLastMovementsTable;" class="hover:tw-bg-gray-50 tw-transition-colors"></tr>
                            </table>
                        </div>
                    </div>
                }
            </section>
        </ng-container>
    
        <ng-container formGroupName="printersForm">
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.PRINTERS</mat-label>
    
            <div class="tw-flex tw-flex-wrap md:tw-flex-nowrap tw-items-center tw-justify-between tw-p-4 tw-mx-2">
                <div class="tw-flex tw-items-center tw-gap-3 tw-truncate tw-flex-grow tw-min-w-[200px]">
                    <mat-icon class="tw-text-gray-500 tw-hidden md:tw-inline-block tw-min-w-fit">print</mat-icon>
                    <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-1 tw-truncate">
                        <span [appTruncatedText]="itemGeneralFormService.getEnabledPrintersDescription()"
                            class="tw-whitespace-nowrap tw-truncate">
                            {{itemGeneralFormService.getEnabledPrintersDescription()}}
                        </span>
                        <span class="tw-hidden md:tw-inline tw-text-gray-400 tw-mx-1">—</span>
                        <span [appTruncatedText]="itemGeneralFormService.getEnabledPrintersName()" 
                            class="tw-font-bold tw-truncate">
                            {{ itemGeneralFormService.getEnabledPrintersName() }}
                        </span>
                    </div>
                </div>
                
                <div class="tw-w-full sm:tw-w-auto tw-flex tw-justify-start sm:tw-justify-end tw-mt-2 sm:tw-mt-0">
                    <button mat-button color="primary" (click)="showMorePrinters = !showMorePrinters" type="button">
                        <mat-icon>{{ showMorePrinters ? 'expand_less' : 'expand_more' }}</mat-icon>
                        {{ (showMorePrinters ? 'COMMON.SHOW_LESS' : 'COMMON.SHOW_MORE') | translate }}
                    </button>
                </div>
            </div>
    
            @if(showMorePrinters) {
                <div class="tw-px-6" formArrayName="printers">
                    <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4">
                        @for(printer of itemGeneralFormService.printersArray?.controls; track printer; let i = $index) {
                            <div [formGroupName]="i" class="tw-flex tw-items-start">
                                <mat-checkbox formControlName="_enabled" [disabled]="printer.value._categoryEnabled">
                                    <div class="tw-flex tw-flex-col">
                                        <span class="tw-font-medium">{{ printer.value.name }}</span>
                                        @if(printer.value._categoryEnabled) {
                                            <span class="tw-text-[12px] tw-font-medium">
                                                {{ 'ITEMS.DETAILS.CATEGORY_ENABLED' | translate }}
                                            </span>
                                        }
                                    </div>
                                </mat-checkbox>
                            </div>
                        }
                    </div>
                </div>
            }
        </ng-container>
    </form>
}
